/*
* @描述: 更换负责人
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/24 16:16
*/
<template>
    <van-dialog v-model="dialogVisible"
                confirm-button-color="#2990FF"
                show-cancel-button
                title="更换负责人"
                @cancel="handleDialogClose"
                @confirm="handleDialogConfirm">
        <el-form ref="changePersonForm"
                 :model="changePersonForm"
                 :rules="changePersonFormRules"
                 class="team_members_form">
            <el-form-item  prop="salesperson">
                <el-select v-model="changePersonForm.salesperson"
                           :remote-method="getUserOptions"
                           filterable
                           placeholder="请选择人员，可输入人员姓名搜索"
                           remote>
                    <el-option v-for="item in userOptions"
                               :key="item.uid"
                               :label="item.name"
                               :value="item.uid"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
    </van-dialog>
</template>
<script>
import {GetUserList, projectSalespersonChange} from "@/api";

export default {
    name: "BusinessAddMember",
    data() {
        return {
            changePersonForm: {
                salesperson: '',
            },
            changePersonFormRules: {
                salesperson: [
                    {required: true, message: '请选择人员', trigger: 'change'}
                ]
            },
            userOptions: [],
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        project_ids: {
            type: Array,
            default: () => []
        }
    },
    created() {
        this.getUserOptions()
    },
    methods: {
        //获取用户列表
        getUserOptions(keyword) {
            GetUserList({keyword}).then(res => {
                if (res.code === 200) {
                    this.userOptions = res.data || []
                } else {
                    this.$toast(res.message)
                }
            })
        },

        // 关闭弹窗
        handleDialogClose() {
            this.$emit('update:dialogVisible', false)
        },

        // 确定
        handleDialogConfirm() {
            this.$refs.changePersonForm.validate(valid => {
                if (valid) {
                    projectSalespersonChange({
                        project_ids: this.project_ids,
                        salesperson: this.changePersonForm.salesperson,
                    }).then(res => {
                        if (res.code === 200) {
                            this.$toast.success('更换成功')
                            this.$emit('update:dialogVisible', false)
                            this.$emit('refresh')
                        }
                    })
                } else {

                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.team_members_form {
    padding: 20px 16px 0;
    .el-select {
        width: 100%;
    }
}
</style>